(function () {
  if (window.__shortDescriptionClampBound) return;
  window.__shortDescriptionClampBound = true;

  var SELECTOR = '[data-short-description-clamp]';
  var READY_CLASS = 'is-clamp-ready';

  function getMaxLines(el) {
    var lines = parseInt(el.getAttribute('data-max-lines'), 10);
    return lines > 0 ? lines : 3;
  }

  function getLineHeightPx(el) {
    var computed = window.getComputedStyle(el);
    var lineHeight = parseFloat(computed.lineHeight);
    if (!isNaN(lineHeight)) return lineHeight;
    var fontSize = parseFloat(computed.fontSize) || 14;
    return fontSize * 1.4;
  }

  function getSentences(el) {
    var raw = el.getAttribute('data-sentences');
    if (!raw) return null;
    try {
      var sentences = JSON.parse(raw);
      return Array.isArray(sentences) && sentences.length ? sentences : null;
    } catch (e) {
      return null;
    }
  }

  function fitsWithinHeight(el, text, maxHeight) {
    el.textContent = text;
    return el.scrollHeight <= maxHeight + 1;
  }

  // Builds text out of *whole* sentences aimed at the height budget. Never
  // cuts a sentence short and never adds an ellipsis. A sentence that would
  // push slightly past the limit is still kept in full as long as there is
  // an unfilled line to spill into, so the block reaches the target line
  // count instead of stopping short — a small (1-2 word) overflow to finish
  // a sentence is preferred over dropping it.
  function fitBySentence(el, sentences, maxHeight) {
    var accumulated = '';
    var best = sentences[0];

    for (var i = 0; i < sentences.length; i++) {
      var candidate = accumulated ? accumulated + ' ' + sentences[i] : sentences[i];

      if (accumulated === '') {
        accumulated = candidate;
        best = candidate;
        continue;
      }

      // The full candidate still fits: take it and keep going.
      if (fitsWithinHeight(el, candidate, maxHeight)) {
        accumulated = candidate;
        best = candidate;
        continue;
      }

      // The candidate overflows. Keep the whole overflowing sentence only if
      // the text so far hasn't yet filled the line budget (there's still an
      // empty line for it to start on); otherwise stop before it.
      el.textContent = accumulated;
      if (el.scrollHeight < maxHeight) {
        best = candidate;
      }
      break;
    }

    return best;
  }

  function clampElement(el) {
    var sentences = getSentences(el);
    if (!sentences) return;

    // Disable the native box-clamp first so scrollHeight reflects the true,
    // unclamped content height while we measure sentence combinations.
    el.classList.add(READY_CLASS);

    var maxHeight = getLineHeightPx(el) * getMaxLines(el);
    el.textContent = fitBySentence(el, sentences, maxHeight);
  }

  function clampAll(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(clampElement);
  }

  var pendingFrame;
  function scheduleClamp(scope) {
    cancelAnimationFrame(pendingFrame);
    pendingFrame = requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        clampAll(scope);
      });
    });
  }

  scheduleClamp();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () {
      scheduleClamp();
    });
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      scheduleClamp();
    }, 150);
  });

  document.addEventListener('shopify:section:load', function (event) {
    scheduleClamp(event.target);
  });
})();
